/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Grid, Table, Icon, Button, Segment, Input } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { S3_BASE_URL } from '../../config/API';

function ScreensaverComponent({
  loading,
  showImageList,
  onClickOnAddNew,
  onClickOnDelete,
  onClickOnEdit,
  onChangeOnSearchName,
}) {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered padded style={{ paddingTop: '8vh', paddingBottom: '12vh' }}>
      <Helmet>
        <title>Image List </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Image List
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={14} >
          <Button
            floated="right"
            basic
            color="blue"
            onClick={onClickOnAddNew}
          >
            ADD NEW
          </Button>
          <Input
            floated="left"
            label="Search Image Name"
            placeholder="Image Name"
            onChange={onChangeOnSearchName}
          />

          <Table celled fixed style={{ marginTop: '7vh' }} >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Id</Table.HeaderCell>
                <Table.HeaderCell>Image Path</Table.HeaderCell>
                <Table.HeaderCell>Image Type</Table.HeaderCell>
                <Table.HeaderCell>VM Type</Table.HeaderCell>
                <Table.HeaderCell>Added on</Table.HeaderCell>
                <Table.HeaderCell>Image</Table.HeaderCell>
                <Table.HeaderCell>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
              showImageList.map(image => (
                <Table.Row>
                  <Table.Cell>
                    {image.id}
                  </Table.Cell>
                  <Table.Cell style={{ overflowWrap: 'break-word' }}>
                    {image.screen_saver_url.split('/')[1]}
                  </Table.Cell>
                  <Table.Cell>
                    {image.image_type}
                  </Table.Cell>
                  <Table.Cell>
                    {image.vm_type}
                  </Table.Cell>
                  <Table.Cell>
                    {moment
                            .utc(image.since)
                            .local()
                            .format('DD-MM-YYYY HH:mm:ss')}
                  </Table.Cell>
                  <Table.Cell >
                    <img src={`${S3_BASE_URL}/${image.screen_saver_url}`} alt="" style={{ width: '100%', height: '80px' }} />
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      basic
                      icon
                      color="blue"
                      onClick={() => onClickOnEdit(image.id)}
                    >
                      <Icon name="pencil" />
                    </Button>
                    <Button
                      basic
                      icon
                      color="red"
                      onClick={() => onClickOnDelete(image.id, image.screen_saver_url.split('/')[1])}
                    >
                      <Icon name="delete" />
                    </Button>
                  </Table.Cell>
                </Table.Row>
              ))
          }
              <Table.Row />

            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default ScreensaverComponent;



// WEBPACK FOOTER //
// ./src/Modules/ImageList/component.jsx